import * as React from "react";

import { Div } from "containers/Responsive";
import { Div3 } from "containers/Responsive/Div3";

export interface RootComponentProps {
  location: any;
  match: any;
  history: any;
}

// eslint-disable-next-line @typescript-eslint/ban-types
export class AbstractRootComponent<S = {}> extends React.Component<
  RootComponentProps,
  S
> {
  protected showHeader: boolean;
  protected showFooter: boolean;
  protected showSideMenu: boolean;
  protected renderOn3Views: boolean;
  protected className?: string;

  public constructor(props: RootComponentProps) {
    super(props);
    this.showHeader = true;
    this.showFooter = true;
    this.showSideMenu = true;
    this.renderOn3Views = false;
  }

  public body(): React.ReactNode {
    return <></>;
  }

  public header(): React.ReactNode {
    return <></>;
  }

  public footer(): React.ReactNode {
    return <></>;
  }

  public render() {
    const pageContent = (
      <>
        <header id="react-header">{this.showHeader && this.header()}</header>
        <div id="react-body">{this.body()}</div>
        <footer id="react-footer">{this.showFooter && this.footer()}</footer>
      </>
    );

    return this.renderOn3Views ? (
      <Div3 id="component-root" className={this.className}>
        {pageContent}
      </Div3>
    ) : (
      <Div id="component-root" className={this.className}>
        {pageContent}
      </Div>
    );
  }
}
